// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class JanssenGECheckRequestModel {
    static getAttributeTypeMap() {
        return JanssenGECheckRequestModel.attributeTypeMap;
    }
}
JanssenGECheckRequestModel.discriminator = undefined;
JanssenGECheckRequestModel.attributeTypeMap = [
    {
        "name": "tcProgramId",
        "baseName": "tcProgramId",
        "type": "number"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "uniqueId",
        "baseName": "uniqueId",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "ScriptsTempJanssenGECheckPatient"
    }
];
//# sourceMappingURL=janssenGECheckRequestModel.js.map